export default __webpack_public_path__ + "static/media/ADVANCED CONTEXTUAL co-logo-dark-text-50.14220dbb.webp";